import { rd, type RemoteData } from '@passionware/monads';
import { useMemo } from 'react';
import { type MediaPin } from 'v5/patterns/widgets/MediaCarousel/mediaCarousel.types';
import { useResourceAssociations } from './useResourceAssociations';

export type ResourcePin = MediaPin;

export type UseResourcePinsResult = RemoteData<ResourcePin[]>;

export function useResourcePins(resourceId: number): UseResourcePinsResult {
  const associations = useResourceAssociations(resourceId);
  return useMemo(
    () =>
      rd.map(associations, ({ pins = [] }) =>
        pins.filter(pin => !pin.archived)
      ),
    [associations]
  );
}
